export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-en.f11e2dd6.png";